export default
[
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'Home',
    action: 'read',
  },
  /*
  {
    title: 'Regions',
    route: 'regions',
    icon: 'MapIcon',
  },
   */
  {
    title: 'Dashboards',
    route: 'dashboards',
    icon: 'GridIcon',
    tagVariant: 'light-primary',
    resource: 'Dashboard',
    action: 'read',
  },

  /*
  {
    title: 'Favourite',
    icon: 'HeartIcon',
    tag: '5',
    tagVariant: 'light-danger',
    resource: 'Dashboard',
    action: 'read',
    children: [
      {
        title: 'eCommerce',
        route: 'dashboard-ecommerce',
        icon: 'GridIcon',
        resource: 'Dashboard',
        action: 'read',
      },
      {
        title: 'Analytics',
        route: 'dashboard-analytics',
        icon: 'GridIcon',
        resource: 'Dashboard',
        action: 'read',
      },
    ],
  },
  */
  {
    header: 'Entites',
  },

  {
    title: 'Sites',
    route: 'sites',
    icon: 'MapPinIcon',
    resource: 'Site',
    action: 'read',
  },
  {
    title: 'Objects',
    route: 'objects',
    icon: 'BoxIcon',
    resource: 'Object',
    action: 'read',
  },
  {
    title: 'Devices',
    route: 'devices',
    icon: 'CpuIcon',
    resource: 'Device',
    action: 'read',
  },
  {
    header: 'Settings',
  },
  {
    title: 'Settings',
    route: 'settingsPage',
    icon: 'SettingsIcon',
    resource: 'Settings',
  },
]
